// extracted by mini-css-extract-plugin
export default {"modalTitle":"modal-dealer_modalTitle__ZFOSW","modalForm":"modal-dealer_modalForm__rLsnQ","actions":"modal-dealer_actions__sQYMw"};